/**
 * 404 page shown for unknown learner-app routes.
 */
import { Box } from "@mui/material";
import React from "react";

import VText from "form/VText";

/**
 * Renders the not-found illustration and copy.
 */
const Page404 = () => {
  return (
    <Box className="w-full h-full flex justify-center items-center">
      <VText className="text-5xl">404 PAGE</VText>
    </Box>
  );
};

export default Page404;
